import { getPlans, type Plan } from '@otter-ai/recall-client';
import { HOUR_MS } from '../constants/time';
import type { AdditionalQueryOptions } from '../shared/utils/queryCreators';

type PlansQueryKey = ['plans'];

const staleTime = 2 * HOUR_MS; // Data stays fresh for 2 hours

type AdditionalPlansQueryOptions = AdditionalQueryOptions<
  Plan[],
  PlansQueryKey
>;

export type PlansQuery = {
  readonly queryKey: PlansQueryKey;
  readonly queryFn: () => Promise<Plan[]>;
} & AdditionalPlansQueryOptions;

/**
 * Create a query to fetch details about subscription plans
 *
 * @example
 * ```tsx
 * * const { data: plans } = useQuery(plansQueryCreator(123));
 * ```
 */

export function plansQueryCreator(
  additionalOptions: AdditionalPlansQueryOptions = {},
): PlansQuery {
  return {
    ...additionalOptions,
    staleTime,
    queryKey: ['plans'],
    queryFn: async () => {
      const response = await getPlans();
      if (response.error) {
        throw response.data;
      }
      return response.data.plans;
    },
  };
}
